import instance from './instance'

const transactionUrl = 'modules-lead/transactions'

export const getTransactionList = (page: number, pageSize: number, filterKey: any) =>
  instance.get(`${transactionUrl}?page=${page}&pageSize=${pageSize}&filterkey=${filterKey}`)

export const updateTransactionList = (id: any, payload: any) =>
  instance.post(`${transactionUrl}/${id}`, payload)